/**
 * @generated SignedSource<<0b65832f71d7d5982a1a575991a4b3a6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteRequest = {
  id: string;
};
export type AccountsTabArchiveMutation$variables = {
  input: DeleteRequest;
};
export type AccountsTabArchiveMutation$data = {
  readonly archiveAccount: {
    readonly id: string;
  };
};
export type AccountsTabArchiveMutation = {
  response: AccountsTabArchiveMutation$data;
  variables: AccountsTabArchiveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AdminAccount",
    "kind": "LinkedField",
    "name": "archiveAccount",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountsTabArchiveMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AccountsTabArchiveMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a8080cbb29c416bd6ac6a86db87afb84",
    "id": null,
    "metadata": {},
    "name": "AccountsTabArchiveMutation",
    "operationKind": "mutation",
    "text": "mutation AccountsTabArchiveMutation(\n  $input: DeleteRequest!\n) {\n  archiveAccount(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "b3bbeddab6611bbe3e6207d8de620bd2";

export default node;
